import React, { useState } from "react";
import promotionHome from "../../assets/images/promotionHome.png";
import promotionMedicine from "../../assets/images/promotionMedicine.png";
import promotionLab from "../../assets/images/promotionLab.png";
import promotionUpload from "../../assets/images/promotionUpload.png";

interface BannerUploadProps {
  title: string;
  category: string;
  index: number;
}

const BannerUpload: React.FC<BannerUploadProps> = ({
  title,
  category,
  index,
}) => {
  const [activeTab, setActiveTab] = useState<number>(1);

  return (
    <div className="mb-8">
      <div className="flex items-center mb-2">
        <h3 className="text-blue-900 text-sm font-light">{title} Banners</h3>
        <div className="ml-auto flex">
          {[1, 2, 3].map((tab) => (
            <button
              key={tab}
              className={`w-6 h-6 rounded-sm text-xs flex items-center justify-center mr-1 ${
                activeTab === tab
                  ? "bg-green-500 text-white"
                  : "bg-white border border-gray-300 text-gray-600"
              }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      <div className="border border-gray-200 bg-gray-100 rounded-md p-4 flex flex-col items-center justify-center h-32">
        <button className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center mb-2">
          <img src={promotionUpload} alt="not-found" />
        </button>
        <p className="text-sm text-center mb-1">Click here to upload</p>
        <p className="text-xs text-gray-500">
          Recommended 500 × 140 JPEG or PNG
        </p>
      </div>
    </div>
  );
};

interface PromotionsProps {
  onSave?: () => void;
}

export const StockPromotionsView: React.FC<PromotionsProps> = ({
  onSave = () => {},
}) => {
  const categories = ["Home", "Medicine", "Lab Test"];
  const bannerTypes = ["Primary", "Secondary", "Territory"];

  return (
    <div className="bg-white rounded-lg border border-blue-200">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 mb-4 px-4 pt-4">
        <h2 className="text-lg font-semibold text-gray-800">Promotions</h2>
        <button
          style={{ background: "#199C4D" }}
          className="text-white px-6 py-2 rounded-md text-sm sm:text-base"
          onClick={onSave}
        >
          Save
        </button>
      </div>

      {/* Divider */}
      <div className="border-b border-gray-200 mb-4"></div>

      {/* Promotion Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((category, categoryIndex) => (
          <div
            key={categoryIndex}
            className={`flex flex-col px-4 py-3 border-b border-gray-200 ${categoryIndex !== 2 ? "lg:border-r" : ""
              }`}
          >
            {/* Category Header */}
            <div className="flex items-center mb-3">
              <div className="w-6 h-6 flex items-center justify-center rounded-md">
                {categoryIndex === 0 ? (
                  <img src={promotionHome} alt="not-found" className="w-5 h-5" />
                ) : categoryIndex === 1 ? (
                  <img src={promotionMedicine} alt="not-found" className="w-5 h-5" />
                ) : (
                  <img src={promotionLab} alt="not-found" className="w-5 h-5" />
                )}
              </div>
              <span
                className="ml-2 text-sm font-medium"
                style={{ color: "#771F52" }}
              >
                {category}
              </span>
            </div>

            {/* Banner Uploads */}
            {bannerTypes.map((bannerType, index) => (
              <BannerUpload
                key={index}
                title={bannerType}
                category={category}
                index={index}
              />
            ))}
          </div>
        ))}
      </div>
    </div>

  );
};
